const ApiBaseUrl = process.env.VUE_APP_API_BASE_URL;

export default {
  getMe(token) {
    return fetch(`${ApiBaseUrl}brugerinfo`, {
      method: 'GET',
      headers: new Headers({
        'Authorization': 'Bearer ' + token,
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if ((response.errors && response.errors[0].title === 'Authorization has been denied for this request.') ||
          (response.message && response.message.indexOf('JWSError') === 0)) {
          localStorage.removeItem('token');
          throw new Error('Bruger er blevet logget ud. Log ind igen.');
        }
        const user = response.length ? response[0] : null;
        return user;
      })
      .catch(error => {
        localStorage.removeItem('token');
        throw error;
      });
  },
  // trips
  createTrip(trip, user) {
    const data = _trip2ApiTrip(trip, user);
    return fetch(`${ApiBaseUrl}rute`,
      {
        method: 'POST',
        headers: _getHeaders(),
        body: JSON.stringify(data),
      }
    )
      .then(response => {
        return response.headers.get('location').split('id=eq.')[1];
      })
      .catch(error => {
        throw error;
      });
  },
  updateTrip(tripId, trip) {
    const filter = '?id=eq.' + tripId;
    const data = _trip2ApiTrip(trip);
    return fetch(`${ApiBaseUrl}rute${filter}`,
      {
        method: 'PATCH',
        headers: _getHeaders(),
        body: JSON.stringify(data),
      }
    )
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  deleteTrip(tripId) {
    const filter = '?id=eq.' + tripId;
    return fetch(`${ApiBaseUrl}rute${filter}`,
      {
        method: 'DELETE',
        headers: _getHeaders(),
      }
    )
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  getTrip(tripId) {
    const filter = '?id=eq.' + tripId;
    return fetch(`${ApiBaseUrl}rute${filter}`,
      {
        method: 'GET',
        headers: _getHeaders(),
      }
    )
      .then(response => {
        return response.json();
      })
      .then(response => {
        return _apiTrip2Trip(response[0]);
      })
      .catch(error => {
        throw error;
      });
  },
  getTrips(user) {
    const filter = '?oprettet_af=eq.' + user.bruger_id;
    return fetch(`${ApiBaseUrl}rute${filter}`,
      {
        method: 'GET',
        headers: _getHeaders(),
      }
    )
      .then(response => {
        return response.json();
      })
      .then(response => {
        var trips = [];
        response.forEach(element => {
          trips.push(_apiTrip2Trip(element));
        });
        return trips;
      })
      .catch(error => {
        throw error;
      });
  },
  updateTripTitle(tripId, title) {
    const filter = '?id=eq.' + tripId;
    const data = {
      navn: title,
    };
    return fetch(`${ApiBaseUrl}rute${filter}`,
      {
        method: 'PATCH',
        headers: _getHeaders(),
        body: JSON.stringify(data),
      }
    )
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  createUser(email, name) {
    return fetch(`${ApiBaseUrl}bruger`,
      {
        method: 'POST',
        headers: _getHeaders(),
        body: JSON.stringify({ 'email': email, 'navn': name, 'institution_id': process.env.VUE_APP_DEFAULT_INSTITUTIONID, 'aktiv': true }),
      }
    )
      .then(response => {
        return response.headers.get('location').split('id=eq.')[1];
      })
      .catch(error => {
        throw error;
      });
  },
  updateUserName(userId, name) {
    const filter = '?id=eq.' + userId;
    const data = {
      navn: name,
    };
    return fetch(`${ApiBaseUrl}bruger${filter}`,
      {
        method: 'PATCH',
        headers: _getHeaders(),
        body: JSON.stringify(data),
      }
    )
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  updateUserInstitution(userId, institutionId) {
    const filter = '?id=eq.' + userId;
    const data = {
      institution_id: institutionId,
    };
    return fetch(`${ApiBaseUrl}bruger${filter}`,
      {
        method: 'PATCH',
        headers: _getHeaders(),
        body: JSON.stringify(data),
      }
    )
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  getInstitutioner(kommunenr) {
    const filter = `?kommune_nr=eq.${kommunenr}&order=navn`;
    return fetch(`${ApiBaseUrl}institution${filter}`,
      {
        method: 'GET',
        headers: _getHeaders(),
      }
    )
      .then(response => {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  },
};

function _getHeaders() {
  let headers = {
    'Content-Type': 'application/json; charset=utf-8',
  };
  if (localStorage.getItem('token') !== null) {
    headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  }
  return new Headers(headers);
}

function _trip2ApiTrip(trip, user) {
  var result = {
    navn: trip.title,
    beskrivelse: '',
    rute_info: trip,
    status: 1,
  };
  if (user) {
    result.oprettet_af = user.bruger_id;
  }
  return result;
}

function _apiTrip2Trip(trip) {
  var result = trip.rute_info;
  result.id = trip.id;
  result.title = trip.navn;
  return result;
}
